const initials = "specialSlotStudent/";

export const UPDATE_SPECIAL_SLOT_STUDENT_DATA = `${initials}UPDATE_SPECIAL_SLOT_STUDENT_DATA`;